import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { VendorLoginService } from '../shared/services/vendor-login.service';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-vendorforgotpassword',
  templateUrl: './vendorforgotpassword.component.html',
  styleUrls: ['./vendorforgotpassword.component.scss']
})
export class VendorforgotpasswordComponent {
  mailId: string = '';
  isLoading: boolean = false;
 
  constructor(
    private vendorLoginService: VendorLoginService,
    private toastr: ToastrService,
    private router: Router
  ) {}
  submit(forgotPasswordForm: NgForm) {
  if (forgotPasswordForm.invalid) {
    this.toastr.error('Please enter a valid email address.');
    return;
  }
 
  this.isLoading = true;
 
  this.vendorLoginService.vendorforgotpassword({ mailId: this.mailId }).subscribe({
    next: (res: any) => {
      this.isLoading = false;
      console.log('Response:', res);
 
      if (res) {
        this.toastr.success('OTP sent successfully!');
       
        if (this.mailId) {
          console.log('Navigating to OTP page with mailId:', this.mailId);
          this.router.navigate(['/vendor-verify-otp'], {
            queryParams: { mailId: this.mailId }
          });
        } else {
          this.toastr.error('Invalid email address.');
        }
      } else {
        this.toastr.error('Failed to send OTP.');
      }
    },
    error: (err) => {
      this.isLoading = false;
      console.error('Error in API call:', err);
      this.toastr.error('Something went wrong!');
    }
  });
}

}
